import * as React from 'react'
import BaseIcon from 'react-icon-base'

const ArrowUpIcon = props => (
  <BaseIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx="8" cy="8" r="8" fill="#2DD8A7" fillRule="nonzero" opacity=".1" />
      <path fill="#2ED8A7" d="M12 10L8 6l-4 4z" />
    </g>
  </BaseIcon>
)

export default ArrowUpIcon
